(() => {
  const obsoleteProductPath = '/products/orela-night-reset';
  const currentProductPath = '/products/night-reset';

  const rewriteObsoleteProductLinks = (root = document) => {
    root.querySelectorAll(`a[href^="${obsoleteProductPath}"]`).forEach((link) => {
      const target = new URL(link.href, window.location.origin);
      if (target.pathname !== obsoleteProductPath) return;
      target.pathname = currentProductPath;
      link.href = `${target.pathname}${target.search}${target.hash}`;
    });
  };

  rewriteObsoleteProductLinks();
  document.addEventListener('shopify:section:load', (event) => rewriteObsoleteProductLinks(event.target));

  if (customElements.get('orela-header')) return;

  class OrelaHeader extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.openButton = this.querySelector('[data-orela-menu-open]');
      this.layer = this.querySelector('[data-orela-menu-layer]');
      this.panel = this.querySelector('[data-orela-menu-panel]');
      this.closeButtons = [...this.querySelectorAll('[data-orela-menu-close]')];
      this.menuLinks = [...this.querySelectorAll('[data-orela-menu-panel] a[href]')];
      this.lastFocusedElement = null;
      this.closeTimer = null;

      this.handleOpen = this.openMenu.bind(this);
      this.handleClose = this.closeMenu.bind(this);
      this.handleKeydown = this.onKeydown.bind(this);
      this.handleLinkClick = () => this.closeMenu(false);

      this.openButton?.addEventListener('click', this.handleOpen);
      this.closeButtons.forEach((button) => button.addEventListener('click', this.handleClose));
      this.menuLinks.forEach((link) => link.addEventListener('click', this.handleLinkClick));
      document.addEventListener('keydown', this.handleKeydown);
      if (this.openButton && this.layer && this.panel) this.setAttribute('data-menu-ready', '');
    }

    disconnectedCallback() {
      this.openButton?.removeEventListener('click', this.handleOpen);
      this.closeButtons?.forEach((button) => button.removeEventListener('click', this.handleClose));
      this.menuLinks?.forEach((link) => link.removeEventListener('click', this.handleLinkClick));
      document.removeEventListener('keydown', this.handleKeydown);
      this.removeAttribute('data-menu-ready');
      window.clearTimeout(this.closeTimer);
      document.body.classList.remove('orela-mobile-menu-open');
      this.initialized = false;
    }

    openMenu() {
      if (!this.layer || !this.panel) return;

      window.clearTimeout(this.closeTimer);
      this.lastFocusedElement = document.activeElement;
      this.layer.hidden = false;
      this.layer.setAttribute('aria-hidden', 'false');
      this.openButton?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('orela-mobile-menu-open');

      window.requestAnimationFrame(() => {
        this.layer.classList.add('is-open');
        this.panel.querySelector('[data-orela-menu-close]')?.focus();
      });
    }

    closeMenu(restoreFocus = true) {
      if (!this.layer || this.layer.hidden) return;

      this.layer.classList.remove('is-open');
      this.openButton?.setAttribute('aria-expanded', 'false');
      window.clearTimeout(this.closeTimer);

      this.closeTimer = window.setTimeout(() => {
        this.layer.hidden = true;
        this.layer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('orela-mobile-menu-open');
        if (restoreFocus) this.lastFocusedElement?.focus();
      }, 280);
    }

    onKeydown(event) {
      if (!this.layer || this.layer.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeMenu();
        return;
      }

      if (event.key !== 'Tab' || !this.panel) return;

      const focusable = [
        ...this.panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      ];
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('orela-header', OrelaHeader);
})();
